import React, { useMemo } from "react";
// import { shallowEqual, useSelector } from "react-redux";

import { useHtmlClassService } from "../../_core/MetronicLayout";
// import { toAbsoluteUrl } from "../../../_helpers";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  // const { userType } = useSelector(
  //   (state) => ({
  //     userType: state.auth.user.userType
  //   }),
  //   shallowEqual
  // );

  return (
    <div
      className={`footer bottom-0 position-fixed w-100 bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">{today.toString()}</span> &copy;{" "}
          <a
            href="/"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            Quiz App
          </a>
        </div>
        <div className="nav nav-dark order-1 order-md-2">
          {/* <a
            href="/logout"
            rel="noopener noreferrer"
            className="nav-link pr-3 pl-0"
          >
            {userType === 'Student' && <span>Switch to Teacher</span>}
            {userType === 'Teacher' && <span>Switch to Student</span>}
          </a> */}
          <a
            href="/"
            rel="noopener noreferrer"
            className="nav-link pr-3 pl-0"
          >
            Privacy
          </a>
          <a
            href="/"
            rel="noopener noreferrer"
            className="nav-link px-3"
          >
            Legal
          </a>
          <a
            href="/"
            rel="noopener noreferrer"
            className="nav-link pl-3 pr-0"
          >
            Contact
          </a>
        </div>
      </div>
    </div>
  );
}
